import React, { useState } from 'react';
import { NEUTRAL, STATUS_COLORS } from './designTokens';

function BookingAnamnesisView({
  theme,
  anamnesisLoading,
  anamnesisQuestions,
  templateIntro,
  setTemplateIntro,
  editingIntro,
  setEditingIntro,
  saveTemplate,
  addingQuestion,
  setAddingQuestion,
  newQuestion,
  setNewQuestion,
  editingQuestion,
  setEditingQuestion,
  addQuestion,
  saveQuestion,
  deleteQuestion,
  moveQuestion,
}) {
  const [deletingQuestionId, setDeletingQuestionId] = useState(null);

  return (
    <div style={{ background: theme.card_bg, border: `1px solid ${theme.card_border}`, borderRadius: theme.card_radius, boxShadow: theme.card_shadow, overflow: 'hidden' }}>
      <div style={{ padding: '14px 20px', borderBottom: `1px solid ${theme.card_border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '10px' }}>
          <h2 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: NEUTRAL.ink, fontFamily: 'var(--font-heading)' }}>Anamnesmall</h2>
          <span style={{ fontSize: '12px', color: NEUTRAL.muted }}>Visas för kunden inför bokning tills den är ifylld</span>
        </div>
        {!addingQuestion && (
          <button type="button" onClick={() => setAddingQuestion(true)} style={{ background: 'none', border: 'none', color: theme.accent_text, fontSize: '12px', fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit', padding: 0, whiteSpace: 'nowrap' }}>+ Ny fråga</button>
        )}
      </div>

      <div style={{ padding: '20px' }}>

        {anamnesisLoading ? (
          <p style={{ color: theme.text_secondary }}>Laddar...</p>
        ) : (
          <div>
            {/* Introtext */}
            <div style={{ marginBottom: '20px', paddingBottom: '18px', borderBottom: `1px solid ${theme.card_border}` }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '6px' }}>
                <span style={{ fontSize: '11px', fontWeight: '600', color: NEUTRAL.muted, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Intro till kunden</span>
                {!editingIntro && (
                  <button onClick={() => setEditingIntro(true)} style={{ background: 'none', border: 'none', color: theme.text_secondary, cursor: 'pointer', fontSize: '0.8em', padding: '0' }}>
                    Ändra
                  </button>
                )}
              </div>
              {editingIntro ? (
                <div>
                  <textarea
                    value={templateIntro}
                    onChange={(e) => setTemplateIntro(e.target.value)}
                    placeholder="Din terapeut vill veta lite mer om dig inför ditt besök. Det tar bara ett par minuter."
                    rows={3}
                    style={{ width: '100%', padding: '10px 12px', borderRadius: '7px', border: `1px solid ${theme.card_border}`, fontSize: '0.875em', outline: 'none', resize: 'vertical', boxSizing: 'border-box', lineHeight: '1.5' }}
                  />
                  <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                    <button onClick={saveTemplate} style={{ background: theme.accent, color: 'white', border: 'none', padding: '7px 16px', borderRadius: theme.btn_radius, cursor: 'pointer', fontSize: '0.875em', fontWeight: '500' }}>Spara</button>
                    <button onClick={() => setEditingIntro(false)} style={{ background: 'none', border: `1px solid ${theme.card_border}`, color: theme.text_secondary, padding: '7px 12px', borderRadius: theme.btn_radius, cursor: 'pointer', fontSize: '0.875em' }}>Avbryt</button>
                  </div>
                </div>
              ) : (
                <p style={{ margin: 0, color: templateIntro ? NEUTRAL.text : theme.text_secondary, fontSize: '0.9em', lineHeight: '1.6', fontStyle: templateIntro ? 'normal' : 'italic' }}>
                  {templateIntro || 'Din terapeut vill veta lite mer om dig inför ditt besök. Det tar bara ett par minuter.'}
                </p>
              )}
            </div>

            {/* Frågor - räknare */}
            <div style={{ marginBottom: '12px' }}>
              <span style={{ fontSize: '0.875em', fontWeight: '600', color: NEUTRAL.text }}>Frågor ({anamnesisQuestions.length})</span>
            </div>

            {/* Formulär: Ny fråga */}
            {addingQuestion && (
              <div style={{ border: `1px solid ${theme.card_border}`, borderRadius: '10px', padding: '16px 18px', marginBottom: '12px', background: theme.card_bg }}>
                <p style={{ margin: '0 0 12px', fontSize: '0.875em', fontWeight: '600', color: NEUTRAL.text }}>Ny fråga</p>
                <div style={{ marginBottom: '10px' }}>
                  <label style={{ display: 'block', fontSize: '0.8em', fontWeight: '500', color: NEUTRAL.text, marginBottom: '4px' }}>Frågans text</label>
                  <input
                    value={newQuestion.question_text}
                    onChange={(e) => setNewQuestion(q => ({ ...q, question_text: e.target.value }))}
                    placeholder="T.ex. Har du tidigare skador vi bör känna till?"
                    style={{ width: '100%', padding: '9px 12px', borderRadius: '7px', border: `1px solid ${theme.card_border}`, fontSize: '0.875em', outline: 'none', boxSizing: 'border-box' }}
                  />
                </div>
                <div style={{ display: 'flex', gap: '16px', marginBottom: '12px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
                  <div>
                    <label style={{ display: 'block', fontSize: '0.8em', fontWeight: '500', color: NEUTRAL.text, marginBottom: '4px' }}>Svarstyp</label>
                    <select
                      value={newQuestion.question_type}
                      onChange={(e) => setNewQuestion(q => ({ ...q, question_type: e.target.value }))}
                      style={{ padding: '8px 12px', borderRadius: '7px', border: `1px solid ${theme.card_border}`, fontSize: '0.875em', outline: 'none', background: 'white' }}
                    >
                      <option value="text">Kort svar</option>
                      <option value="textarea">Långt svar</option>
                      <option value="yes_no">Ja / Nej</option>
                    </select>
                  </div>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontSize: '0.875em', color: NEUTRAL.text, paddingBottom: '2px' }}>
                    <input
                      type="checkbox"
                      checked={newQuestion.is_required}
                      onChange={(e) => setNewQuestion(q => ({ ...q, is_required: e.target.checked }))}
                    />
                    Obligatorisk
                  </label>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={addQuestion} style={{ background: theme.accent, color: 'white', border: 'none', padding: '7px 16px', borderRadius: theme.btn_radius, cursor: 'pointer', fontSize: '0.875em', fontWeight: '500' }}>Lägg till</button>
                  <button onClick={() => { setAddingQuestion(false); setNewQuestion({ question_text: '', question_type: 'text', is_required: false }); }} style={{ background: 'none', border: `1px solid ${theme.card_border}`, color: theme.text_secondary, padding: '7px 12px', borderRadius: theme.btn_radius, cursor: 'pointer', fontSize: '0.875em' }}>Avbryt</button>
                </div>
              </div>
            )}

            {/* Lista frågor */}
            {anamnesisQuestions.length === 0 && !addingQuestion ? (
              <div style={{ textAlign: 'center', padding: '36px 20px', border: `1px dashed ${theme.card_border}`, borderRadius: '10px' }}>
                <p style={{ margin: '0 0 4px', fontWeight: '600', color: NEUTRAL.text }}>Inga frågor ännu</p>
                <p style={{ margin: 0, color: theme.text_secondary, fontSize: '0.875em' }}>Klicka "+ Ny fråga" för att börja bygga din anamnesblankett.</p>
              </div>
            ) : (
              anamnesisQuestions.map((q, index) => (
                <div key={q.id} style={{ borderTop: `1px solid ${theme.card_border}`, padding: '12px 0' }}>
                  {editingQuestion?.id === q.id ? (
                    <div>
                      <div style={{ marginBottom: '10px' }}>
                        <input
                          value={editingQuestion.question_text}
                          onChange={(e) => setEditingQuestion(eq => ({ ...eq, question_text: e.target.value }))}
                          style={{ width: '100%', padding: '9px 12px', borderRadius: '7px', border: `1px solid ${theme.card_border}`, fontSize: '0.875em', outline: 'none', boxSizing: 'border-box' }}
                        />
                      </div>
                      <div style={{ display: 'flex', gap: '16px', marginBottom: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
                        <select
                          value={editingQuestion.question_type}
                          onChange={(e) => setEditingQuestion(eq => ({ ...eq, question_type: e.target.value }))}
                          style={{ padding: '7px 10px', borderRadius: '7px', border: `1px solid ${theme.card_border}`, fontSize: '0.875em', outline: 'none', background: 'white' }}
                        >
                          <option value="text">Kort svar</option>
                          <option value="textarea">Långt svar</option>
                          <option value="yes_no">Ja / Nej</option>
                        </select>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontSize: '0.875em', color: NEUTRAL.text }}>
                          <input
                            type="checkbox"
                            checked={editingQuestion.is_required}
                            onChange={(e) => setEditingQuestion(eq => ({ ...eq, is_required: e.target.checked }))}
                          />
                          Obligatorisk
                        </label>
                      </div>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button onClick={() => saveQuestion(q.id)} style={{ background: theme.accent, color: 'white', border: 'none', padding: '6px 14px', borderRadius: theme.btn_radius, cursor: 'pointer', fontSize: '0.82em', fontWeight: '500' }}>Spara</button>
                        <button onClick={() => setEditingQuestion(null)} style={{ background: 'none', border: `1px solid ${theme.card_border}`, color: theme.text_secondary, padding: '6px 10px', borderRadius: theme.btn_radius, cursor: 'pointer', fontSize: '0.82em' }}>Avbryt</button>
                      </div>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                          <span style={{ fontSize: '0.78em', color: theme.text_secondary, fontWeight: '600' }}>{index + 1}.</span>
                          <span style={{ fontSize: '0.9em', color: NEUTRAL.ink, fontWeight: '500' }}>{q.question_text}</span>
                        </div>
                        <div style={{ display: 'flex', gap: '6px', marginTop: '5px', flexWrap: 'wrap' }}>
                          <span style={{ background: NEUTRAL.page, color: NEUTRAL.muted, padding: '2px 8px', borderRadius: '10px', fontSize: '0.75em', fontWeight: '500' }}>
                            {{ text: 'Kort svar', textarea: 'Långt svar', yes_no: 'Ja / Nej' }[q.question_type]}
                          </span>
                          {q.is_required && (
                            <span style={{ background: STATUS_COLORS.error_bg, color: STATUS_COLORS.error, padding: '2px 8px', borderRadius: '10px', fontSize: '0.75em', fontWeight: '500' }}>Obligatorisk</span>
                          )}
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '2px', marginLeft: '12px', flexShrink: 0, alignItems: 'center' }}>
                        {index > 0 && (
                          <button onClick={() => moveQuestion(q.id, -1)} style={{ background: 'none', border: `1px solid ${theme.card_border}`, color: theme.text_secondary, cursor: 'pointer', padding: '3px 7px', borderRadius: '4px', fontSize: '0.82em' }}>↑</button>
                        )}
                        {index < anamnesisQuestions.length - 1 && (
                          <button onClick={() => moveQuestion(q.id, 1)} style={{ background: 'none', border: `1px solid ${theme.card_border}`, color: theme.text_secondary, cursor: 'pointer', padding: '3px 7px', borderRadius: '4px', fontSize: '0.82em' }}>↓</button>
                        )}
                        <button onClick={() => setEditingQuestion({ ...q })} style={{ background: 'none', border: 'none', color: theme.text_secondary, cursor: 'pointer', padding: '3px 8px', borderRadius: '4px', fontSize: '0.82em', textDecoration: 'underline' }}>Redigera</button>
                        {deletingQuestionId === q.id ? (
                          <>
                            <button onClick={() => { deleteQuestion(q.id); setDeletingQuestionId(null); }} style={{ background: 'none', border: '1px solid #fca5a5', color: STATUS_COLORS.error, cursor: 'pointer', padding: '3px 8px', borderRadius: '4px', fontSize: '0.82em', fontWeight: '600', whiteSpace: 'nowrap' }}>Bekräfta</button>
                            <button onClick={() => setDeletingQuestionId(null)} style={{ background: 'none', border: `1px solid ${theme.card_border}`, color: theme.text_secondary, cursor: 'pointer', padding: '3px 8px', borderRadius: '4px', fontSize: '0.82em', whiteSpace: 'nowrap' }}>Avbryt</button>
                          </>
                        ) : (
                          <button onClick={() => setDeletingQuestionId(q.id)} style={{ background: 'none', border: 'none', color: theme.text_secondary, cursor: 'pointer', padding: '3px 8px', borderRadius: '4px', fontSize: '0.82em', textDecoration: 'underline' }}>Ta bort</button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default BookingAnamnesisView;
